import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { EnvelopeSimpleIcon as EnvelopeSimple } from "@phosphor-icons/react";

const VARS = "{{cliente}} · {{numero_preventivo}} · {{oggetto}} · {{importo}} · {{data_preventivo}} · {{data_scadenza}} · {{data_accettazione}}";

export function AcceptConfigSection() {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/crm/accettazione-config").then(({ data }) => setCfg(data)).catch(() => {}); }, []);
  if (!cfg) return null;
  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/crm/accettazione-config", {
        email_notifica_accettazione_interna: cfg.email_notifica_accettazione_interna || "",
        oggetto_email_cliente_accettazione: cfg.oggetto_email_cliente_accettazione || "",
        testo_email_cliente_accettazione: cfg.testo_email_cliente_accettazione || "",
        oggetto_email_interna_accettazione: cfg.oggetto_email_interna_accettazione || "",
        testo_email_interna_accettazione: cfg.testo_email_interna_accettazione || "",
      });
      setCfg(data); toast.success("Impostazioni accettazione salvate");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Card className="rounded-sm border-border shadow-none p-6 mb-6" data-testid="accept-config-section">
      <div className="flex items-center gap-3 mb-4">
        <div className="h-10 w-10 rounded-sm bg-secondary flex items-center justify-center"><EnvelopeSimple size={20} weight="bold" className="text-primary" /></div>
        <div>
          <h3 className="font-heading font-semibold">Accettazione preventivi</h3>
          <p className="text-xs text-muted-foreground">Email inviate quando un cliente accetta online un preventivo{!cfg.m365_configured && " · ⚠ Microsoft 365 non configurato: le email non verranno inviate"}</p>
        </div>
      </div>
      <div className="space-y-4">
        <div>
          <Label className="text-xs uppercase tracking-wider">Email notifica interna</Label>
          <Input value={cfg.email_notifica_accettazione_interna || ""} onChange={(e) => set("email_notifica_accettazione_interna", e.target.value)} placeholder="commerciale@tecnologieverona.it" className="mt-1 rounded-sm" data-testid="accept-email-interna" />
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          <div>
            <Label className="text-xs uppercase tracking-wider">Oggetto email cliente</Label>
            <Input value={cfg.oggetto_email_cliente_accettazione || ""} onChange={(e) => set("oggetto_email_cliente_accettazione", e.target.value)} className="mt-1 rounded-sm" data-testid="accept-oggetto-cliente" />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-wider">Oggetto email interna</Label>
            <Input value={cfg.oggetto_email_interna_accettazione || ""} onChange={(e) => set("oggetto_email_interna_accettazione", e.target.value)} className="mt-1 rounded-sm" data-testid="accept-oggetto-interna" />
          </div>
        </div>
        <div>
          <Label className="text-xs uppercase tracking-wider">Testo email cliente</Label>
          <Textarea value={cfg.testo_email_cliente_accettazione || ""} onChange={(e) => set("testo_email_cliente_accettazione", e.target.value)} rows={5} className="mt-1 rounded-sm" data-testid="accept-testo-cliente" />
        </div>
        <div>
          <Label className="text-xs uppercase tracking-wider">Testo email interna</Label>
          <Textarea value={cfg.testo_email_interna_accettazione || ""} onChange={(e) => set("testo_email_interna_accettazione", e.target.value)} rows={5} className="mt-1 rounded-sm" data-testid="accept-testo-interna" />
        </div>
        <p className="text-[11px] text-muted-foreground">Variabili disponibili: {VARS}</p>
        <Button onClick={save} disabled={saving} className="rounded-sm" data-testid="save-accept-config-btn">{saving ? "Salvataggio..." : "Salva impostazioni"}</Button>
      </div>
    </Card>
  );
}
